import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleProp, StyleSheet, Text, TextStyle } from 'react-native';

type Props = {
	username: string;
	style: StyleProp<TextStyle>;
	/** Size of the name, larger than the rest of the line so it stands out. */
	usernameFontSize: number;
	numberOfLines?: number;
};

// A private-use character no translation contains, standing in for the name while the line is
// split around it.
const NAME_MARK = '';

/**
 * "Donation to {{username}}" with the name highlighted, so it is plain the purchase is for that
 * player. The translation decides where the name goes in the sentence.
 */
const DonationToText = ({ username, style, usernameFontSize, numberOfLines }: Props) => {
	const { t } = useTranslation();
	const line = t('T_SITE_DONATION_TO', {
		defaultValue: 'Donation to {{username}}',
		username: NAME_MARK,
	});
	const [before, after] = line.split(NAME_MARK);

	return (
		<Text numberOfLines={numberOfLines} style={style}>
			{after === undefined ? (
				line
			) : (
				<>
					{before}
					<Text style={[styles.username, { fontSize: usernameFontSize }]}>{username}</Text>
					{after}
				</>
			)}
		</Text>
	);
};

const styles = StyleSheet.create({
	username: {
		color: '#FFFFFF',
		fontWeight: '900',
		// The confirmation's heading has a gold shadow; the name goes without it.
		textShadowColor: 'transparent',
		textShadowRadius: 0,
	},
});

export default DonationToText;
